<template>
  <div>
    <header
      class="masthead"
      style="background-image: url('assets/img/mixer-1322136__480.jpg')"
    >
      <div class="overlay"></div>
      <div class="container">
        <div class="row">
          <div class="col-md-10 col-lg-8 mx-auto">
            <div class="site-heading">
              <h1>PORTAFOLIO</h1>
            </div>
          </div>
        </div>
      </div>
    </header>

    <div class="container">
      <h2><b>Producción Musical</b></h2>
      <p>EP de cuatro canciones del artista FEDE grabado por la productora</p>
      <div class="player-dimequehacer">
        <b>DIME QUE HACER</b>
        <hr />
        <iframe
          width="100%"
          height="166"
          scrolling="no"
          frameborder="no"
          allow="autoplay"
          src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/683995097&color=%236b006b&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"
        ></iframe>
        <div
          style="
            font-size: 10px;
            color: #cccccc;
            line-break: anywhere;
            word-break: normal;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-family: Interstate, Lucida Grande, Lucida Sans Unicode,
              Lucida Sans, Garuda, Verdana, Tahoma, sans-serif;
            font-weight: 100;
          "
        >
          <a
            href="https://soundcloud.com/melody-record-311846035"
            title="Melody Record"
            target="_blank"
            style="color: #cccccc; text-decoration: none"
            >Melody Record</a
          >
          ·
          <a
            href="https://soundcloud.com/melody-record-311846035/01-dime-que-hacer"
            title="01 Dime Que Hacer"
            target="_blank"
            style="color: #cccccc; text-decoration: none"
            >01 Dime Que Hacer</a
          >
        </div>
        <hr />
      </div>

      <div class="player-angeldeamor">
        <b>ANGEL DE AMOR</b>
        <hr />
        <iframe
          width="100%"
          height="166"
          scrolling="no"
          frameborder="no"
          allow="autoplay"
          src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/683995081&color=%236b006b&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"
        ></iframe>
        <div
          style="
            font-size: 10px;
            color: #cccccc;
            line-break: anywhere;
            word-break: normal;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-family: Interstate, Lucida Grande, Lucida Sans Unicode,
              Lucida Sans, Garuda, Verdana, Tahoma, sans-serif;
            font-weight: 100;
          "
        >
          <a
            href="https://soundcloud.com/melody-record-311846035"
            title="Melody Record"
            target="_blank"
            style="color: #cccccc; text-decoration: none"
            >Melody Record</a
          >
          ·
          <a
            href="https://soundcloud.com/melody-record-311846035/02-angel-de-amor"
            title="02 Angel De Amor"
            target="_blank"
            style="color: #cccccc; text-decoration: none"
            >02 Angel De Amor</a
          >
        </div>
        <hr />
      </div>

      <div class="player-reina">
        <b>REINA</b>
        <hr />
        <iframe
          width="100%"
          height="166"
          scrolling="no"
          frameborder="no"
          allow="autoplay"
          src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/683995053&color=%236b006b&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"
        ></iframe>
        <div
          style="
            font-size: 10px;
            color: #cccccc;
            line-break: anywhere;
            word-break: normal;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-family: Interstate, Lucida Grande, Lucida Sans Unicode,
              Lucida Sans, Garuda, Verdana, Tahoma, sans-serif;
            font-weight: 100;
          "
        >
          <a
            href="https://soundcloud.com/melody-record-311846035"
            title="Melody Record"
            target="_blank"
            style="color: #cccccc; text-decoration: none"
            >Melody Record</a
          >
          ·
          <a
            href="https://soundcloud.com/melody-record-311846035/03-reina"
            title="03 Reina"
            target="_blank"
            style="color: #cccccc; text-decoration: none"
            >03 Reina</a
          >
        </div>
        <hr />
      </div>

      <div class="player-quiero">
        <b>QUIERO</b>
        <hr />
        <iframe
          width="100%"
          height="166"
          scrolling="no"
          frameborder="no"
          allow="autoplay"
          src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/683995025&color=%236b006b&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"
        ></iframe>
        <div
          style="
            font-size: 10px;
            color: #cccccc;
            line-break: anywhere;
            word-break: normal;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-family: Interstate, Lucida Grande, Lucida Sans Unicode,
              Lucida Sans, Garuda, Verdana, Tahoma, sans-serif;
            font-weight: 100;
          "
        >
          <a
            href="https://soundcloud.com/melody-record-311846035"
            title="Melody Record"
            target="_blank"
            style="color: #cccccc; text-decoration: none"
            >Melody Record</a
          >
          ·
          <a
            href="https://soundcloud.com/melody-record-311846035/04-quiero"
            title="04 Quiero"
            target="_blank"
            style="color: #cccccc; text-decoration: none"
            >04 Quiero</a
          >
        </div>
        <br><br><br>
        <hr/>
        <br><br><br>
      </div>
    </div>

    <div class="container">
      <h2><b>Sesiones Fotográficas</b></h2>
      <p>Se le realizaron sesiones Fotográficas al artista FEDE</p>

      <div class="carousel">
        <b-carousel
          id="carousel-1"
          v-model="slide"
          :interval="4000"
          controls
          indicators
          background="#ababab"
          img-width="1024"
          img-height="480"
          style="text-shadow: 1px 1px 2px #333"
          @sliding-start="onSlideStart"
          @sliding-end="onSlideEnd"
        >
          <b-carousel-slide   img-src="assets/img/unnamed (2).jpg">
          </b-carousel-slide>

          <b-carousel-slide img-src="assets/img/unnamed.jpg">
          </b-carousel-slide>

          <b-carousel-slide img-src="assets/img/rwgwg.jpg">
          </b-carousel-slide>

          <!-- Slides with img slot -->
          <!-- Note the classes .d-block and .img-fluid to prevent browser default image alignment -->
          <b-carousel-slide>
            <template #img>
              <img
                class="d-block img-fluid w-100"
                width="1024"
                height="480"
                src="assets/img/IMG_9652123.jpg"
                alt="image slot"
              />
            </template>
          </b-carousel-slide>

          <b-carousel-slide
            img-src="assets/img/IMG_9807.jpg" 
          ></b-carousel-slide>

          <b-carousel-slide
            img-src="assets/img/IMG_9801.jpg"
          ></b-carousel-slide>

          <b-carousel-slide
            img-src="assets/img/IMG_9721.jpg"
          ></b-carousel-slide>

          <b-carousel-slide
            img-src="assets/img/IMG_9716.jpg"
          ></b-carousel-slide>

          <b-carousel-slide
            img-src="assets/img/IMG_9807.jpg"
          ></b-carousel-slide>
        </b-carousel>
      </div>
        <br><br><br>
        <hr/>
        <br><br><br>
    </div>

    <div class="container">
      <h2><b>Piezas Gráficas</b></h2>
      <p>
        Las piezas gráficas se crearon para promocionar el videoclip y el EP del artista
      </p>

      <div>
        <b-card-group deck>
          <b-card
            title="DIME QUE HACER"
            img-src="https://i1.sndcdn.com/artworks-ngi0Te2ygFCftoTB-3zMwTg-t500x500.jpg"
            img-alt="Image"
            img-top
          >
            <b-card-text>
             <!-- Pieza Gráfica de la primera canción del EP -->
            </b-card-text>
          </b-card>

          <b-card
            title="ANGEL DE AMOR"
            img-src="assets/img/angel de amor.jpg"
            img-alt="Image"
            img-top
          >
            <!-- <b-card-text> Pieza Gráfica de la segunda canción </b-card-text> -->
          </b-card>

          <b-card
            title="REINA"
            img-src="assets/img/reina.jpg"
            img-alt="Image"
            img-top
          >
            <!-- <b-card-text>Pieza Gráfica de la tercera canción </b-card-text> -->
          </b-card>

          <b-card
            class="quiero"
            title="QUIERO"
            img-src="assets/img/quiero.jpg"
            img-alt="Image"
            img-top
          >
            <!-- <b-card-text> Pieza Gráfica de la cuarta canción </b-card-text> -->
          </b-card>
        </b-card-group>
      </div>
        <br><br><br>
        <hr/>
        <br><br><br>
    </div>

    <div class="container">
      <h2><b>Producciones Audiovisulales</b></h2>
      <br />
      <p>
     Se realizo la grabacion y edicion de video para crear un adelanto del videoclips

      </p>

      <div>
        <b>TEASER</b>
        <hr />
        <iframe
          width="100%"
          height="315"
          src="https://www.youtube.com/embed/Xvf5SxtulWs"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
        <hr />
        <b>VIDEOCLIP</b>
        <hr />
        <iframe
          width="100%"
          height="315"
          src="https://www.youtube.com/embed/r0F0wscSoRY"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
        <hr />
        <h2><b>Otros proyectos Audiovisuales</b></h2>
        <p>se han realizado otras ediciones de videos para uso personal</p>
        <hr />
        <video controls>
          <source
            src="assets/img/PROYECTO FINAL ANIDADA2.0.mp4"
            type="video/mp4"
            width="50%"
          />
        </video>

        <video controls>
          <source
            src="assets/img/SPOT PUBLICITARIO.mp4"
            type="video/mp4"
            width="50%"
          />
        </video>
  
        <video controls>
          <source
            src="assets/img/RANCHO ESPERANZA(subtitulado).mp4"
            type="video/mp4"
            width="50%"
          />
        </video>
 <br><br><br>
        <h3><b>Mas videos en el siguiente link</b></h3>
        <a
          href="https://drive.google.com/drive/folders/1n9LbkVHVQvpt3TjUJSWyhtehVQgQx9nt?usp=sharing"
          target="_blank"
          >VER MAS...</a
        >
        <hr /> 
        <br> <br>
      </div>
        <h5 class="py-2">INFORMACIÓN DE CONTACTO</h5>
        <div class="fondo">
          <div>
            <b-card-group deck>
              <b-card title="Teléfono">
                <i class="fas fa-phone-alt fa-1x"></i>
                <b-card-text class="text"> +569-86570072 </b-card-text>
              </b-card>

              <b-card title="Email">
                <i class="fas fa-at fa-1x"></i>
                <b-card-text class="text"> melody.recordcl@gmail.com </b-card-text>
              </b-card>

              <b-card title="Dirección">
                <i class="fas fa-map-marker-alt fa-1x"></i>
                <b-card-text class="text">
                  Villa Alemana, Región de Valparaiso.
                </b-card-text>
              </b-card>
            </b-card-group>
          </div>
        </div>
        <footer>
          <div class="container">
            <div class="row">
              <div class="col-md-10 col-lg-8 mx-auto">
                <ul class="list-inline text-center">
                  <li class="list-inline-item">
                    <a
                      class="twitt"
                      href="https://twitter.com/home?lang=es"
                      target="_blank"
                      ><span class="fa-stack fa-lg"
                        ><i class="fab fa-twitter fa-1x"></i></span
                    ></a>
                  </li>
                  <li class="list-inline-item">
                    <a
                      class="face"
                      href="https://www.facebook.com/melody.recordcl"
                      target="_blank"
                      ><span class="fa-stack fa-lg">
                        <i class="fab fa-facebook fa-1x"></i
                      ></span>
                    </a>
                  </li>
                  <!-- <li class="list-inline-item">
                <span class="fa-stack fa-lg"
                  ><i class="fa fa-circle fa-stack-2x"></i
                  ><i class="fa fa-github fa-stack-1x fa-inverse"></i
                ></span>
              </li> -->
                </ul>
                <p class="text-center copyright">
                  Copyright&nbsp;©&nbsp;MELODY RECORD
                </p>
              </div>
            </div>
          </div>
        </footer>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      slide: 0,
      sliding: null,
    };
  },
  methods: {
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
  },
};
</script>


<style scoped>

.text {
  text-align: center;
}

h5 {
  text-align: center;
}

.quiero img {
  height: 150px;
}

video {
  width: 80% !important;
}
p {
  font-family: sans-serif;
  font-size: 18px;
  text-align: justify;
}
h2 {
  font-family: sans-serif;
  color: #610f8b;
}
h1{
  font-family: fantasy;
}
.card {
  border-radius: inherit;
  background-color: rgb(70, 20, 110);
  color: white;
}

.twitt {
  color: black;
}
.face {
  color: black;
}
.fa-2x {
    font-size: 2em;
    margin-top: -6px;
}
.fas {
  margin-top: 5px;
  padding-bottom: 6px;
}

.fondo {
  text-align: center;
}

footer .copyright {
  font-size: 14px !important;
}

a {
    color: #610f8b;

}

@media only screen and (min-width: 320px)
{

iframe{
  width: 60%;
}


video {
  width:60% !important;
}
}


@media only screen and (max-width: 990px)
{
video {
  width:100% !important;
}

iframe{
  width: 100%;
}


}


</style>